import { Typography } from "@material-ui/core";
import TimelapseIcon from '@material-ui/icons/Timelapse';

const Messageing = () => {

    return (
        <Typography>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <TimelapseIcon className="in-progress-icon"></TimelapseIcon>
                <div>Coming Soon</div>
            </div>

        </Typography>
    );
}

export default Messageing;